import { call, ForkEffect, put, select, takeLatest } from "redux-saga/effects";

import {
  profileActions,
  fetchProfilesSuccessAction,
  fetchProfilesFailureAction,
  createProfileSuccessAction,
  createProfileFailureAction,
  updateProfileSuccessAction,
  updateProfileFailureAction,
  setLoggedInUserProfileCompleted,
  IRegisterOrganizationAction,
  registerOrganizationActionSuccess,
  registerOrganizationActionFailure,
  IOrganizationData,
  fetchOrganizationSuccessAction,
  fetchOrganizationFailureAction,
  IOrganizationsData,
  IUpdateOrganizationAction,
  updateOrganizationSuccessAction,
  updateOrganizationFailureAction,
} from "./actions";
import Navigator from "@navigator/index";

import { ProfileRepository } from "@common/domain/repositories/ProfileRepository";
import {
  ICreateProfileAction,
  ICreateProfileSuccessActionPayload,
  IProfileData,
  IProfileMap,
  IUpdateProfileAction,
} from "./interface";
import { isProfileDataCompleted } from "./utils";
import { getcurrentLoggedinUserprofileIdSelector } from "./selectors";
function* getUsersSaga(action: ICreateProfileAction) {
  try {
    const {} = action.payload;
    const response = yield call(
      ProfileRepository.fetchUserProfiles,
      action.payload
    ); //what type should i define here for response.
    const profileMap: IProfileMap = response.data.content;

    yield put(fetchProfilesSuccessAction(profileMap));
  } catch (e) {
    yield put(fetchProfilesFailureAction(e.message));
  }
}

function* getOrganizationSaga(action: any) {
  try {
    const organizationsData: IOrganizationsData = yield call(
      ProfileRepository.fetchOrganizationData,
      action.payload
    );
    yield put(fetchOrganizationSuccessAction(organizationsData));
  } catch (e) {
    yield put(fetchOrganizationFailureAction(e.message));
  }
}

function* updateUserProfileSaga(action: IUpdateProfileAction) {
  try {
    const response = yield call(
      ProfileRepository.updateProfileData,
      action.payload
    );
    const currentLoggedinUserId: string = yield select(
      getcurrentLoggedinUserprofileIdSelector
    );
    if (currentLoggedinUserId === response?.data?.userId) {
      yield put(
        setLoggedInUserProfileCompleted(isProfileDataCompleted(response.data))
      );
    }
    yield put(updateProfileSuccessAction(response.data));
  } catch (e) {
    yield put(updateProfileFailureAction(e.message));
  }
}

function* createUserProfileSaga(action: ICreateProfileAction) {
  try {
    const updatedProfileData: ICreateProfileSuccessActionPayload = yield call(
      ProfileRepository.createProfileData,
      action.payload
    );

    yield put(createProfileSuccessAction(updatedProfileData));
  } catch (e) {
    yield put(createProfileFailureAction(e.message));
  }
}
function* registerOrganizationSaga(action: IRegisterOrganizationAction) {
  try {
    const response = yield call(
      ProfileRepository.registerOrganization,
      action.payload
    );
    const responseData: IOrganizationData = response.data;
    yield put(registerOrganizationActionSuccess(responseData));
  } catch (e) {
    yield put(registerOrganizationActionFailure(e.message));
  }
}

function* updateOrganizationSaga(action: IUpdateOrganizationAction) {
  try {
    const response = yield call(
      ProfileRepository.updateOrganization,
      action.payload
    );
    const responseData: IOrganizationData = response.data;
    yield put(updateOrganizationSuccessAction(responseData));
  } catch (e) {
    yield put(updateOrganizationFailureAction(e.message));
  }
}
export function* watchProfile(): Generator<ForkEffect> {
  yield takeLatest(profileActions.FETCH_PROFILES, getUsersSaga);
  yield takeLatest(profileActions.CREATE_PROFILE, createUserProfileSaga);
  yield takeLatest(
    profileActions.UPDATE_PROFILE_DETAILS,
    updateUserProfileSaga
  );
  yield takeLatest(
    profileActions.REGISTER_ORGANISATION,
    registerOrganizationSaga
  );
  yield takeLatest(profileActions.FETCH_ORGANIZATION, getOrganizationSaga);
  yield takeLatest(profileActions.UPDATE_ORGANISATION, updateOrganizationSaga);
}
